export default __webpack_public_path__ + "static/media/payment-method.bfcbf033.svg";